const trackpointScriptId = 'trackpoint-script';

const loadTrackpoint = () => {
  if (document.getElementById(trackpointScriptId) || window.trackPoint) return;

  const trackpointScript = document.createElement('script');
  if (document.getElementsByTagName('head')[0].getAttribute('data-merge-with-paegmeta') === 'Y') {
    trackpointScript.src = 'https://d2ywvfgjza5nzm.cloudfront.net/trackpoint-seshat.js';
  } else {
    trackpointScript.src = 'https://d2ywvfgjza5nzm.cloudfront.net/trackpoint.js';
  }
  trackpointScript.type = 'text/javascript';
  trackpointScript.id = trackpointScriptId;

  trackpointScript.addEventListener('load', () => {
    if (window.trackpointQueue === undefined) {
      return;
    }

    window.trackpointQueue.forEach((event) => {
      window.trackPoint.trigger(event);
    });
  });

  document.head.appendChild(trackpointScript);
};

export default () => { loadTrackpoint(); };
